import { AppContextType } from "../../../../context/AppContext";
import useAppContext from "../../../../hooks/useAppContext";
import { DateOfBirthAndCityType } from "../../../../static/types/commonTypes/dateOfBirthAndCity";
import { DeathRelatedInfoType } from "../../../../static/types/commonTypes/deathRelatedInfoType";
import { IndividualWithBirthNameType } from "../../../../static/types/commonTypes/individualWithBirthNameType";
import DateOfBirthAndCityComponent from "../../../commonComponents/DateOfBirthAndCity";
import DeathRelatedInfo from "../../../commonComponents/DeathRelatedInfo";
import IndividualWithBirthName from "../../../commonComponents/IndividualWithBirthName";

const DeceasedCivilStatus = () => {

    const {

        individualWithBirthName,
        setIndividualWithBirthName,
        individualWithBirthNameValidity,
        setIndividualWithBirthNameValidity,
        individualWithBirthNameChecked,
        setIndividualWithBirthNameChecked,

        dateOfBirth,
        setDateOfBirth,
        dateOfBirthValidity,
        setDateOfBirthValidity,
        dateOfBirthChecked,
        setDateOfBirthChecked,

        // Death Related Info
        deathRelatedInfo,
        setDeathRelatedInfo,
        deathRelatedInfoValidity,
        setDeathRelatedInfoValidity,
        deathRelatedInfoChecked,
        setDeathRelatedInfoChecked,

    } = useAppContext() as AppContextType

    const updateIndividual = (data: Partial<IndividualWithBirthNameType>) => setIndividualWithBirthName({...individualWithBirthName,...data})
    const updateDateOfBirth = (data: Partial<DateOfBirthAndCityType>) => setDateOfBirth ({...dateOfBirth, ...data});

    return (
        <>
            <div>
                <IndividualWithBirthName
                    individual= {individualWithBirthName}
                    checked= {individualWithBirthNameChecked}
                    changeIndividual= {updateIndividual}
                    onValidationChange={(isValid: boolean) => setIndividualWithBirthNameValidity (isValid)}
                />
                <h6 className='text-bold'
                    style={{backgroundColor: "#4DB0BB", padding: "0.6rem", color: "white"}}>
                        Date et lieu de naissance
                </h6>
                <DateOfBirthAndCityComponent
                    dateOfBirth= {dateOfBirth}
                    checked= {dateOfBirthChecked}
                    onChange={updateDateOfBirth}
                    onValidationChange={(isValid: boolean) => setDateOfBirthValidity (isValid)}
                />
                <h6 className='text-bold'
                    style={{backgroundColor: "#4DB0BB", padding: "0.6rem", color: "white"}}>
                        Informations liées au décès
                </h6>
                <DeathRelatedInfo
                    checked = { deathRelatedInfoChecked }
                    deathRelatedInfo = { deathRelatedInfo }
                    onChange = {( partialData: Partial<DeathRelatedInfoType>) => setDeathRelatedInfo({ ...deathRelatedInfo, ...partialData })}
                    onValidationChange = {( isValid: boolean ) => setDeathRelatedInfoValidity( isValid )}
                />

            </div>
        </>
    )
}

export default DeceasedCivilStatus;